import { SlidersHorizontal } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";

import BadgeWrapper from "common/components/BadgeWrapper";
import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import type { ProfileSearchParams } from "common/types";

import useSearchSourceParams from "../../../../hooks/useSearchSourceParams";
import FiltersSelection from "./FiltersSelection";

export default function MobileFilters({
  accountId,
  searchParams,
  setSearchParams,
}: {
  accountId: string;
  searchParams: ProfileSearchParams;
  setSearchParams: (searchParams: Partial<ProfileSearchParams>) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const { hasFilters, resetFilters } = useSearchSourceParams(
    searchParams,
    setSearchParams,
  );

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <BadgeWrapper
        badgeClassName={clsx("right-0 -top-0 size-4", !hasFilters && "hidden")}
      >
        <DrawerTrigger asChild>
          <Button variant="outline-black" size="lg" intent="iconOnly">
            <SlidersHorizontal />
          </Button>
        </DrawerTrigger>
      </BadgeWrapper>
      <DrawerContent>
        <DrawerHeader
          title="Filter leads"
          actionComponent={
            hasFilters && (
              <Button variant="link-purple" onClick={resetFilters}>
                Clear
              </Button>
            )
          }
        />
        <DrawerBody className="overflow-auto">
          <FiltersSelection
            accountId={accountId}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </DrawerBody>
        <DrawerFooter className="justify-end">
          <DrawerClose asChild>
            <Button>Done</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
